import React, { useEffect, useState } from "react";
import {
  ChatBubbleOvalLeftIcon,
  XMarkIcon,
  ArrowLeftIcon,
  PaperAirplaneIcon,
  ChatBubbleBottomCenterIcon,
} from "@heroicons/react/24/outline";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getChatMessages, getCompanyChats, getMyChats, sendMessage } from "../../../slices/10-chat/thunk";
import SectionLoader from "../../sharedComponents/Loading/SectionLoader";
import avatar from "../../../assets/images/Avatar.avif"
import MainButton from "../../sharedComponents/MainButton";
import { FileText } from "lucide-react";

const MessageMenu = ({ isBellDrawerOpen, toggleBellDrawer }) => {
  const [activeChat, setActiveChat] = useState(null);
  const [messageInput, setMessageInput] = useState("");
  // const [messages, setMessages] = useState([
  //   {
  //     id: 1,
  //     text: "Hey! Did you see the Mars launch news?",
  //     time: "2:30 PM",
  //     date: "Jan 31, 2026",
  //     sender: "other",
  //   },
  //   {
  //     id: 2,
  //     text: "Yes! It's incredible! 🚀",
  //     time: "2:31 PM",
  //     date: "Jan 31, 2026",
  //     sender: "me",
  //   },
  //   {
  //     id: 3,
  //     text: "I'm writing an article about it. Want to collaborate?",
  //     time: "2:32 PM",
  //     date: "Jan 31, 2026",
  //     sender: "other",
  //   },
  // ]);
  const { t, i18n } = useTranslation();
  const locale = i18n.language === "ar" ? "ar" : "en";
  const [selectedMessage, setSelectedMessage] = useState(null);
  const { profile } = useSelector((state) => state.myProfile);
  const dispatch = useDispatch();
  const { chats, messages, loading } = useSelector((state) => state.chat);

  useEffect(() => {
    // console.log(profile)
    if (!profile?.role) return;

    if (profile.role === "owner") {
      dispatch(getCompanyChats());
    } else {
      dispatch(getMyChats());
    }
  }, [profile?.role, dispatch]);

  useEffect(() => {
    if (!activeChat?.id) return;
    // console.log(activeChat?.id)
    dispatch(getChatMessages(activeChat?.id));
  }, [activeChat, dispatch]);
  if (!isBellDrawerOpen) return null;

  const handleSendMessage = async () => {
    if (messageInput.trim()) {

      await dispatch(sendMessage({ chatId: activeChat?.id, content: messageInput }));
      await dispatch(getChatMessages(activeChat?.id));
      setMessageInput("");
    }
  };
  // console.log(chats)
  // console.log(messages)
  // console.log(locale)
  return createPortal(
    <div className="fixed inset-0 z-[9999] flex justify-end ">
      {/* Overlay */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={toggleBellDrawer}
      />

      {/* Drawer */}
      <div className="dark:bg-bg-dark-secondary bg-bg-light-secondary w-[500px] lg:w-[25%] h-full border-l dark:border-border-dark border-border-light flex flex-col relative ">
        {!activeChat ? (
          <>
            {/* Header */}
            <div className="flex items-center justify-between p-6">
              <h2 className="flex items-center text-2xl font-bold text-black dark:text-white">
                <ChatBubbleOvalLeftIcon className="w-7 h-7 me-2 dark:text-primary text-primary-light" />
                {t("chat.title")}
              </h2>
              <XMarkIcon
                onClick={toggleBellDrawer}
                className="text-black cursor-pointer dark:text-white w-7 h-7"
              />
            </div>

            <hr className="dark:border-border-dark border-border-light" />

            {/* Users List */}
            <div className="flex-1 overflow-y-auto no-scrollbar">
              {loading ? <SectionLoader /> : chats?.length === 0 ?
                <div className="flex flex-col items-center justify-center px-4 py-4">
                  <div className="w-full max-w-md p-4 text-center border rounded-2xl bg-bg-light-secondary dark:bg-bg-dark-secondary border-border-light dark:border-border-dark">

                    <ChatBubbleBottomCenterIcon className="w-12 h-12 mx-auto mb-4 dark:text-primary text-primary-light" />

                    <h2 className="mb-2 font-semibold text-black lg:text-xl dark:text-white">
                      {t("chat.emptyTitle")}
                    </h2>

                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      {t("chat.emptyDescription")}
                    </p>

                    {/* <MainButton onClick={() => navigate("/explore")}>
                    {t("chat.startConversation")}
                  </MainButton> */}

                  </div>
                </div> : chats?.map((chat) => (
                  <div
                    key={chat?.id}
                    onClick={() => setActiveChat(chat)}
                    className="flex items-center gap-3 px-6 py-4 transition-colors border-b cursor-pointer dark:hover:bg-bg-dark-tertiary hover:bg-bg-light-tertiary dark:border-border-dark border-border-light"
                  >
                    <div className="relative">
                      <img
                        src={(chat?.Company ? chat?.Company?.logo : chat?.User?.avatar) || avatar}
                        alt={(locale === "ar") ? (chat?.Company ? chat?.Company?.name_EN : chat?.User?.fullName) : (chat?.Company ? chat?.Company?.name_AR : chat?.User?.fullName)}
                        className="w-12 h-12 rounded-full"
                      />
                      <span className="absolute bottom-0 right-0 w-3.5 h-3.5 rounded-full dark:bg-primary bg-primary-light border-2 dark:border-border-dark border-border-light" />
                    </div>

                    <div>
                      <p className="text-lg font-medium text-black dark:text-white">
                        {`${chat?.Company ? locale === "ar" ? chat?.Company?.name_AR : chat?.Company?.name_EN : chat?.User?.fullName}`}
                      </p>
                      {/* <p className="text-sm dark:text-text-muted-dark text-text-muted-light">{t("chat.online")}</p> */}
                      <p className="text-sm dark:text-text-muted-dark text-text-muted-light">{chat?.Messages?.[0]?.content}</p>
                    </div>
                  </div>
                ))}
            </div>
          </>
        ) : (
          /* ================= Chat View ================= */
          <>
            {/* Chat Header */}
            <div className="flex items-center gap-2 p-4 border-b dark:border-border-dark border-border-light">
              <ArrowLeftIcon
                onClick={() => setActiveChat(null)}
                className="w-6 h-6 text-black cursor-pointer dark:text-white rtl:rotate-180"
              />
              <div className="relative">
                <img
                  src={(activeChat?.Company ? activeChat?.Company?.logo : activeChat?.User?.avatar) || avatar}
                  alt={(locale === "ar") ? (activeChat?.Company ? activeChat?.Company?.name_EN : activeChat?.User?.fullName) : (activeChat?.Company ? activeChat?.Company?.name_AR : activeChat?.User?.fullName)}
                  className="w-12 h-12 rounded-full"
                />
                <span className="absolute bottom-0 right-0 w-3 h-3 rounded-full dark:bg-primary bg-primary-lightborder-2 dark:border-border-dark border-border-light" />
              </div>
              <div className="flex-1">
                <p className="font-semibold text-black dark:text-white">
                  {t(`${activeChat?.Company ? (locale === "ar" ? activeChat?.Company?.name_AR : activeChat?.Company?.name_EN) : activeChat?.User?.fullName}`)}

                </p>
                {/* <p className="text-sm dark:text-text-muted-dark text-text-muted-light">{t("chat.online")}</p> */}
              </div>
              <XMarkIcon
                onClick={toggleBellDrawer}
                className="w-6 h-6 text-black cursor-pointer dark:text-white"
              />
            </div>

            {/* Chat Messages */}
            <div className="flex-1 p-6 space-y-4 overflow-y-auto no-scrollbar">
              {[...messages]?.reverse().map((message) => (
                <div
                  key={message?.id}
                  className={`flex  ${!message?.myMessage ? "rtl:justify-end justify-start" : "rtl:justify-start justify-end" || ""
                    }`}
                >
                  <div
                    onClick={() =>
                      setSelectedMessage(
                        selectedMessage === message?.id ? null : message?.id
                      )
                    }
                    className={`px-4 py-3 rounded-2xl max-w-[75%] cursor-pointer transition-all ${message?.myMessage
                      ? "dark:bg-primary bg-primary-light dark:text-black text-white rounded-br-sm"
                      : "dark:bg-bg-dark-tertiary bg-bg-light-tertiary dark:text-white text-black rounded-bl-sm"
                      }`}
                  >
                    <p className="text-[15px] leading-relaxed">{message?.content}</p>
                    <p
                      className={`text-xs mt-1 ${message?.myMessage
                        ? "text-black/60"
                        : "text-gray-400"
                        }`}
                    >
                      {message?.time}
                    </p>
                    {selectedMessage === message?.id && (
                      <p
                        className={`text-xs mt-1 font-medium ${message?.myMessage
                          ? "text-black/70"
                          : "text-gray-300"
                          }`}
                      >
                        {message?.created}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Input */}
            <div className="p-4 border-t dark:border-border-dark border-border-light">
              <div className="flex items-center gap-3">
                <input
                  type="text"
                  value={messageInput}
                  onChange={(e) => setMessageInput(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === "Enter") handleSendMessage();
                  }}
                  placeholder={t("chat.typeMessage")}
                  className="flex-1 px-4 py-3 text-black transition-all outline-none rounded-xl dark:bg-bg-dark-tertiary bg-bg-light-tertiary dark:text-white dark:placeholder-text-muted-dark placeholder-text-muted-light focus:ring-2 dark:focus:ring-primary focus:ring-primary-light"
                />
                <MainButton
                  onClick={handleSendMessage}
                  className="flex items-center justify-center w-12 h-12 transition-all duration-300 rounded-xl dark:bg-primary bg-primary-light shadow-glow hover:shadow-glow-hover active:scale-95"
                >
                  <PaperAirplaneIcon className="w-5 h-5 dark:text-black text-white rtl:-rotate-45  translate-x-0.5" />
                </MainButton>
              </div>
            </div>
          </>
        )}
      </div>
    </div>,
    document.body
  );
};

export default MessageMenu;